import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USERS_FEATURE_KEY, UsersState } from './user.reducer';

export const selectUsersState = createFeatureSelector<UsersState>(USERS_FEATURE_KEY);

export const selectUsers = createSelector(selectUsersState, (state) => state?.data ?? null);
export const selectUserDetail = createSelector(selectUsersState, (state) => state?.detail ?? null);
export const selectUsersTotal = createSelector(selectUsersState, (state) => state?.total ?? 0);
export const selectUsersQuery = createSelector(selectUsersState, (state) => state?.query ?? null);
export const selectUsersLoading = createSelector(selectUsersState, (state) => state?.loading ?? false);
export const selectUsersError = createSelector(selectUsersState, (state) => state?.error ?? null);
